import slider from './Slider'
class Tabs {
  static init( ) {
    this.initTabs();
  }

  static initTabs() {
    let tabsImg = document.querySelectorAll('.img-magasin');
    let tabsLinks= document.querySelectorAll('.tabs-container .nav-link')
    let sliderMarque1 = document.querySelector('#marques1');
    let sliderMarque2 = document.querySelector('#marques2');
    //Trigger action on click of the image
    tabsImg.forEach((el) => {
      if( el.classList.contains('selected')) {
        el.src = el.dataset.select
      }

      el.addEventListener('mouseenter', (e) => {
        e.target.classList.add('hovered');
        el.src = el.dataset.select
      })
      el.addEventListener('mouseleave', (e) => {
        if(e.target.classList.contains('selected')) {
          e.target.classList.remove('hovered');
        }
        else {
          e.target.classList.remove('hovered');
          e.target.src = e.target.dataset.neutral
        }
      })
      el.addEventListener('click', (e) => {
        document.querySelectorAll('.img-magasin').forEach((tab) => {
          tab.classList.remove('selected');
          tab.src = tab.dataset.neutral
        })
        e.target.classList.add('selected');
        e.target.src = e.target.dataset.select
        document.querySelectorAll('.nav-link').forEach((item) => {
          item.classList.remove('active');
        })
        document.querySelectorAll('.tab-pane').forEach((item) => {
          item.classList.remove('show', 'active');
        })

        if( e.target.classList.contains("tab1")) {
          sliderMarque1?.classList.add('active')
          sliderMarque2?.classList.remove('active')
        }
        else if( e.target.classList.contains("tab3")) {
          sliderMarque1?.classList.remove('active')
          sliderMarque2?.classList.add('active')
        }
        else {
          sliderMarque1?.classList.remove('active')
          sliderMarque2?.classList.remove('active')
        }

        el.classList.forEach((name) => {
          if(name.indexOf('tab') == 0) {
            document.getElementById(name).classList.add('active', 'show');
            document.getElementById("nav-" + name).classList.add('active');
          }
        })
      })
    })

    //Change image when tabs is clicked
    tabsLinks.forEach((el) => {
      el.addEventListener('click', (e) => {
        let allImg = document.querySelectorAll('.img-magasin');

        tabsLinks.forEach((item) => {
          item.classList.remove('active');
        })
        e.target.classList.add('active');
        if( e.target.getAttribute('aria-controls') ==  "tab1") {
          sliderMarque1?.classList.add('active')
          sliderMarque2?.classList.remove('active')
        }
        else if (e.target.getAttribute('aria-controls') == "tab3") {
          sliderMarque1?.classList.remove('active')
          sliderMarque2?.classList.add('active')
        }
        else {
          sliderMarque1?.classList.remove('active')
          sliderMarque2?.classList.remove('active')
        }

        let imgToSelect = document.querySelector('.img-magasin.' + e.target.getAttribute('aria-controls'))
        if(imgToSelect) {
          allImg.forEach((itm) => {
            itm.src = itm.dataset.neutral
          })
          imgToSelect.src = imgToSelect.dataset.select
        }
      })
    })
  }
}
export default Tabs;